// libs
import $ from 'jquery'
import "@/lib/jquery-ua.custom"
import purl from "purl/purl.js"
import riot from "riot"
import "sugar"

$.url = purl
require('fancybox')($)

import "@/util/ready"
import "@/util/current"
import "./action/action.js"; import "./action/addOrder.js"; import "./action/nomore.js"; import "./action/sp-menu.js"
import "../riot/debug-bar.tag"; import "../riot/mail-sample/mail-sample.tag"; import "../riot/mail-to.tag"; import "../riot/order/order-item.tag"; import "../riot/product/card-item-category.tag"; import "../riot/product/card-item-select.tag"; import "../riot/product/card-item.tag"; import "../riot/product/card-product.tag"; import "../riot/product/select-group.tag"; import "../riot/riot-mail.tag"; import "../riot/riot-md.tag"; import "../riot/riot-tel.tag"

window.$ = $

import {Actions, Store, types } from '../riot/store'


const dispatcher = riot.observable();
const actions = new Actions(dispatcher);
const store = new Store(dispatcher);

riot.mount("*", {
  $actions: actions,
  $store: store,
  $types: types,
})

window.$store = store



// WEBPACK FOOTER //
// ./_src/js/index.js